import { Collapse } from "@mui/material";
import { InputCheck } from "controls";
import React, { useEffect } from "react";

const PosAccess = ({ values, setValues }) => {
  useEffect(() => {
    if (!values.id) {
      values.posAccess
        ? setValues((j) => ({
            ...j,
            pos: {
              creditSale: true,
              returnSale: true,
              quote: true,
              createCustomer: true,
              discount: true,
              registerClosing: true,
            },
          }))
        : setValues((j) => ({
            ...j,
            pos: {
              creditSale: false,
              returnSale: false,
              quote: false,
              createCustomer: false,
              discount: false,
              registerClosing: false,
            },
          }));
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.posAccess]);

  const handleInpChg = (e) => {
    const { name, checked } = e.target;
    setValues((j) => ({
      ...j,
      pos: { ...j.pos, [name]: checked },
    }));
  };

  return (
    <Collapse in={values.posAccess || false}>
      <div className="ml-[3px] grid gap-1 mt-[2px] mb-[10px] !uppercase tracking-wider !pl-[10px] border-l-4 border-rounded">
        <InputCheck
          label="Credit Sale"
          checked={values.pos?.creditSale || false}
          name={"creditSale"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Return Sale"
          checked={values.pos?.returnSale || false}
          name={"returnSale"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Quote"
          checked={values.pos?.quote || false}
          name={"quote"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Create Customer"
          checked={values.pos?.createCustomer || false}
          name={"createCustomer"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="discount"
          checked={values.pos?.discount || false}
          name={"discount"}
          onClick={handleInpChg}
        />

        <InputCheck
          label="Register Closing"
          checked={values.pos?.registerClosing || false}
          name={"registerClosing"}
          onClick={handleInpChg}
        />
      </div>
    </Collapse>
  );
};

export default PosAccess;
